import { Trophy, Disc3 } from "lucide-react";
import { SectionLabel } from "@/components/ui-nw/UserAvatar";
import { LANDING } from "@/constants/testIds";

const PLAQUES = [
  { name: "Silver Wave", plays: "5,000", ring: "from-slate-200 via-slate-400 to-slate-200", disc: "text-slate-300" },
  { name: "Red Wave", plays: "25,000", ring: "from-red-400 via-nw-red to-red-700", disc: "text-nw-red" },
  { name: "Diamond Wave", plays: "100,000", ring: "from-sky-200 via-white to-sky-400", disc: "text-sky-300" },
];

const PLANS = [
  { name: "Fan", price: "Free", perks: "Listen, watch, follow, like & comment" },
  { name: "Creator", price: "$4.99/mo", perks: "Upload finished AI music & videos", hot: true },
  { name: "Pro", price: "$9.99/mo", perks: "Priority placement & analytics" },
];

export const Plaques = () => (
  <section data-testid={LANDING.plaques} className="space-y-4">
    <SectionLabel>Certified by qualified plays</SectionLabel>
    <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-white">Official Wave Plaques</h2>
    <div className="grid grid-cols-3 gap-3">
      {PLAQUES.map((p) => (
        <div key={p.name} className={`rounded-xl bg-gradient-to-br ${p.ring} p-[2px]`}>
          <div className="h-full rounded-[10px] bg-[#0A0B10] p-3 sm:p-5 text-center">
            <Disc3 className={`mx-auto h-10 w-10 sm:h-14 sm:w-14 ${p.disc}`} strokeWidth={1.2} />
            <p className="mt-3 font-display text-xs sm:text-base font-bold text-white">{p.name}</p>
            <p className="font-mono text-[10px] sm:text-xs text-slate-500">{p.plays} plays</p>
          </div>
        </div>
      ))}
    </div>
  </section>
);

export const ChartTeaser = () => (
  <section data-testid={LANDING.chart} className="relative overflow-hidden rounded-3xl border border-white/10 bg-nw-surface/70 p-6 sm:p-8">
    <div className="pointer-events-none absolute -left-10 -bottom-16 h-48 w-48 rounded-full bg-nw-red/25 blur-3xl" />
    <div className="relative flex items-center gap-5">
      <span className="font-display text-6xl sm:text-7xl font-black chrome-text">20</span>
      <div className="space-y-1">
        <p className="flex items-center gap-2 font-display text-xl font-bold text-white"><Trophy className="h-5 w-5 text-nw-red" /> Weekly Top 20</p>
        <p className="text-sm text-slate-400">The official NEW WAVE AI music chart. Launching with streaming.</p>
      </div>
    </div>
  </section>
);

export const Memberships = () => (
  <section data-testid={LANDING.memberships} className="space-y-4">
    <SectionLabel>Memberships · coming soon</SectionLabel>
    <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-white">Pick your level</h2>
    <div className="grid gap-3 sm:grid-cols-3">
      {PLANS.map((p) => (
        <div key={p.name} data-testid={`membership-plan-${p.name.toLowerCase()}`} className={`rounded-2xl border p-5 ${p.hot ? "border-nw-red/60 bg-nw-red/[0.07] shadow-[0_0_30px_rgba(255,30,39,0.15)]" : "border-white/10 bg-nw-surface/60"}`}>
          <p className="text-xs uppercase tracking-widest text-slate-400">{p.name}</p>
          <p className="mt-1 font-display text-3xl font-extrabold text-white">{p.price}</p>
          <p className="mt-2 text-sm text-slate-400">{p.perks}</p>
        </div>
      ))}
    </div>
  </section>
);
